
import { Component, Vue, Prop } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { API_TTeammates_Pending } from "@/models/company_teammates";
import copy from "copy-to-clipboard";

import {
  SUCCESS_NOTIFICATION_TYPE,
  ERROR_NOTIFICATION_TYPE,
  INFO_NOTIFICATION_TYPE,
} from "@/constants/notification";

const VALUE_EMAIL = "email";
const VALUE_PERMISSION = "permission";
const VALUE_EXPIRATION_DATE = "expirationDate";

const RESEND = "resend";
const LINK = "link";

const EXPIRED_LABEL = "Expired";

@Component
export default class TeammatesPendingInvitesTable extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly teammates!: API_TTeammates_Pending[];
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;

  async resendEmail(id: number, email: string) {
    try {
      await this.axios.get(API_ROUTES.COMPANY_INVITE_LINK(id, RESEND));

      this.$root.$emit("show-notification", {
        type: SUCCESS_NOTIFICATION_TYPE,
        title: this.$tc("notification.inviteEmailIsSent"),
        message: `${email} ${this.$tc("notification.hasBeenInvited")}`,
      });
    } catch (err) {
      this.$root.$emit("show-notification", {
        type: ERROR_NOTIFICATION_TYPE,
        title: this.$tc("notification.error.title"),
        message: this.$tc("notification.error.message"),
      });
    }
  }

  async copyInviteLink(id: number) {
    try {
      const { data } = await this.axios.get<string>(API_ROUTES.COMPANY_INVITE_LINK(id, LINK));

      if (!data) return;

      copy(String(data.link));

      this.$root.$emit("show-notification", {
        type: SUCCESS_NOTIFICATION_TYPE,
        title: this.$tc("notification.inviteLinkCopied"),
      });
    } catch (err) {
      this.$root.$emit("show-notification", {
        type: ERROR_NOTIFICATION_TYPE,
        title: this.$tc("notification.error.title"),
        message: this.$tc("notification.error.message"),
      });
    }
  }

  async deleteInvite(id: number, email: string) {
    try {
      await this.axios.delete<string>(API_ROUTES.COMPANY_INVITE_DELETE(id));

      this.$emit("update");

      this.$root.$emit("show-notification", {
        type: INFO_NOTIFICATION_TYPE,
        title: this.$tc("notification.inviteDeleted"),
        message: `${email} ${this.$tc("notification.wontBeAbleToRegister")}`,
      });
    } catch (err) {
      this.$root.$emit("show-notification", {
        type: ERROR_NOTIFICATION_TYPE,
        title: this.$tc("notification.error.title"),
        message: this.$tc("notification.error.message"),
      });
    }
  }

  get attributes() {
    const { headers, teammates, labels, loading } = this;
    return {
      headers,
      items: teammates,
      labels,
      loading,
    };
  }

  get labels() {
    return {
      allLabel: this.$t("table.allLabel"),
      placeholderLabel: this.$t("table.placeholderLabel"),
    };
  }

  headers = [
    {
      text: this.$t("table.headers.email"),
      value: VALUE_EMAIL,
      filterable: true,
    },
    {
      text: this.$t("table.headers.expirationDate"),
      value: VALUE_EXPIRATION_DATE,
      filterable: true,
      error: EXPIRED_LABEL,
    },

    {
      text: this.$t("table.headers.permission"),
      value: VALUE_PERMISSION,
      filterable: true,
    },
  ];
}
